import RequestedVaspDetails from './RequestedVaspDetails'

export default RequestedVaspDetails
